module.exports = __webpack_public_path__ + "static/media/galeryDoors5.5b0e6db6.jpg";